import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://web-api-sgp.piebarometre.digital/',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem('token'),
  },
})

export default {
  getFinanceProjets () {
    return apiClient.get('api/profil/list-finance-projet')
  },
  createFinanceProjet (financeInformations) {
    const formData = new FormData()
    formData.append('libelle_organisation', financeInformations.libelle_organisation)
    formData.append('adresses', financeInformations.adresses)
    formData.append('directeur', financeInformations.directeur)
    formData.append('telephone', financeInformations.telephone)
    formData.append('email', financeInformations.email)
    formData.append('longitude_organisations', financeInformations.longitude_organisations)
    formData.append('latitude_organisations', financeInformations.latitude_organisations)
    formData.append('logo_organisations', financeInformations.logo_organisations)
    return apiClient.post('api/profil/add-finance-projet', formData)
  },

  updateFinanceProjet (financeInformations) {
    const formData = new FormData()
    formData.append('libelle_organisation', financeInformations.libelle_organisation)
    formData.append('adresses', financeInformations.adresses)
    formData.append('directeur', financeInformations.directeur)
    formData.append('telephone', financeInformations.telephone)
    formData.append('email', financeInformations.email)
    formData.append('longitude_organisations', financeInformations.longitude_organisations)
    formData.append('latitude_organisations', financeInformations.latitude_organisations)
    formData.append('logo_organisations', financeInformations.logo_organisations)
     return apiClient.post(`api/profil/update-finance-projet/${financeInformations.id}`, formData)
  },

  deleteFinanceProjet (financeInformations) {
    return apiClient.post(`api/profil/delete-ofinance-projet/${financeInformations.id}`)
 },
}
